var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('create-educational-material',{attrs:{"editId":_vm.editId,"type":_vm.type,"selectedUserId":_vm.selectedUserId,"currentFolder":_vm.currentFolder,"tumorSites":_vm.tumorSites},on:{"saved":_vm.forwardSaved}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }